/* Native review scrolling, enhanced only with card-aligned controls. */
if (!customElements.get('mce-review-carousel')) {
  customElements.define('mce-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.mce-social-review-rail');
      this.previous = this.querySelector('.mce-review-carousel__button--previous');
      this.next = this.querySelector('.mce-review-carousel__button--next');
      if (!this.rail || !this.previous || !this.next || !window.ResizeObserver) return;

      this.events = new AbortController();
      const signal = this.events.signal;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.rail.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }, { passive: true, signal });
      // Also runs when a CSS-controlled review tab becomes visible.
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.rail);
      if (this.rail.firstElementChild) this.resize.observe(this.rail.firstElementChild);
      this.measure();
      this.setAttribute('data-ready', '');
    }

    measure() {
      if (!this.rail.clientWidth) return;
      this.maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      const cards = [...this.rail.children];
      const first = cards[0]?.offsetLeft || 0;
      this.stops = cards.map(card => Math.min(this.maximum, card.offsetLeft - first));
      this.stops.push(this.maximum);
      this.update();
    }

    update() {
      this.previous.disabled = this.rail.scrollLeft <= 2;
      this.next.disabled = this.rail.scrollLeft >= this.maximum - 2;
      this.toggleAttribute('data-at-end', this.next.disabled);
    }

    move(direction) {
      const position = this.rail.scrollLeft;
      const stops = direction > 0 ? this.stops : [...this.stops].reverse();
      const target = stops.find(stop => direction * (stop - position) > 2);
      if (target === undefined) return;
      this.rail.scrollTo({
        left: target,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.removeAttribute('data-ready');
    }
  });
}
